
export default function isAttributeCheckboxItemSelected(checkboxItem, selectedAttributeIds) {
    return selectedAttributeIds.some(sel => checkboxItem.value.includes(sel));
}
